import {
    faBox,
    faBoxOpen,
    faEnvelope,
    faPenToSquare,
    faQuestionCircle,
    faThumbsUp,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { LowboyAssignmentStatuses } from './LowboyAssignmentStatuses';

export default class LowboyAssignmentStatusIcon extends React.Component {
    render() {
        const { lowboyAssignment } = this.props;

        if (!lowboyAssignment) {
            return null;
        }

        switch (lowboyAssignment.lowboyAssignmentStatusId) {
            case LowboyAssignmentStatuses.Unfilled:
                return (
                    <FontAwesomeIcon
                        icon={faBoxOpen}
                        className="text-muted"
                        title="Unfilled"
                    />
                );
            case LowboyAssignmentStatuses.Unassigned:
                return (
                    <FontAwesomeIcon
                        icon={faBox}
                        className="text-muted"
                        title="Unassigned"
                    />
                );
            case LowboyAssignmentStatuses.Planned:
                return <FontAwesomeIcon icon={faPenToSquare} title="Planned" />;
            case LowboyAssignmentStatuses.Dispatched:
                return (
                    <FontAwesomeIcon
                        icon={faEnvelope}
                        className="text-info"
                        title="Dispatched"
                    />
                );
            case LowboyAssignmentStatuses.Confirmed:
                return (
                    <FontAwesomeIcon
                        icon={faThumbsUp}
                        className="text-success"
                        title="Confirmed"
                    />
                );
            default:
                return <FontAwesomeIcon icon={faQuestionCircle} />;
        }
    }
}
